import { Backend } from '@/_axios';

export default {
  search(name = '') {
    return Backend.get('/users/search', { params: { full_name: name } });
  },
  list(page) {
    return Backend.get('/users/', { params: { page } });
  },
  createData() {
    return Backend.get('/users/create');
  },
  editData(userId) {
    return Backend.get(`/users/${userId}/edit`);
  },
  create(createData) {
    return Backend.post('/users/', createData);
  },
  update(id, updateData) {
    return Backend.put(`/users/${id}`, updateData);
  },
  updateActive(id, isActive) {
    return Backend.put(`/users/${id}/change-active`, { is_active: isActive });
  },
};
